import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import styled from'styled-components';var SPACING = 20;
function FormElement(props) {
  var className = props.className,
    children = props.children,
    otherProps = _objectWithoutProperties(props, ["className", "children"]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, otherProps), children);
}
process.env.NODE_ENV !== "production" ? FormElement.propTypes = {
  className: PropTypes.string,
  spacing: PropTypes.number,
  children: PropTypes.node
} : void 0;
FormElement.defaultProps = {
  className: '',
  spacing: 1,
  children: ''
};
var FormElement$1 = styled(FormElement).withConfig({
  displayName: "FormElement",
  componentId: "sc-1p67wjs-0"
})(["position:relative;width:100%;max-width:409px;padding-top:", "px;padding-bottom:", "px;"], function (props) {
  return (props.spacing || 1) * SPACING - SPACING;
}, function (props) {
  return (props.spacing || 1) * SPACING;
});export{FormElement$1 as default};